// extracted by mini-css-extract-plugin
module.exports = {"artistsGrid__banner":"artistsGrid_artistsGrid__banner__3JBVY","artistsGrid__page":"artistsGrid_artistsGrid__page__BL6MN"};